import React from "react";
import { AppThemeProvider } from "./AppThemeProvider/AppThemeProvider";
import { TeamConfigProvider } from "../components/TeamConfigProvider";
import { NextPageContext } from "next";
import { GlobalModalsProvider } from "./GlobalModalsProvider";
import { ToastContainer } from "react-toastify";
import { SessionUnauthorizedHandler } from "./SessionUnauthorizedHandler";
import { InitialSessionLoaderProvider } from "./InitialSessionLoaderProvider";
import { TeamAnalyticsHeader } from "./TeamAnalyticsHeader";
import { IntercomCtxProvider } from "./IntercomProvider";
import { GlobalAnalyticsHeader } from "./GlobalAnalyticsHeader";
import { OktaProvider } from "./OktaProvider";
import { PageHeadContainer } from "./PageHeadContainer";
import { GlobalApiContainer } from "./GlobalApiContainer";
import MiddlewareIoScriptsContainer from "./MiddlewareIoScriptsContainer";
import { GlobalEventListener } from "./GlobalEventListener";
import { AttributionCaptureProvider } from "./AttributionCaptureProvider";

export const AppProviderRoot = (props: {
  children: React.ReactNode;
  pageProps: NextPageContext;
}) => {
  return (
    <TeamConfigProvider pageProps={props.pageProps}>
      <PageHeadContainer />
      {/* Outside InitialSessionLoaderProvider on purpose: a rep link is clicked
          before login, and that provider withholds its children behind a
          preloader until the session resolves. */}
      <AttributionCaptureProvider>
        <AppThemeProvider>
          <InitialSessionLoaderProvider>
            <OktaProvider>
              <SessionUnauthorizedHandler>
                <ToastContainer position="bottom-left" />
                <GlobalAnalyticsHeader />
                <TeamAnalyticsHeader />
                <GlobalModalsProvider />
                <GlobalApiContainer />
                <GlobalEventListener />
                <IntercomCtxProvider>{props.children}</IntercomCtxProvider>
                <MiddlewareIoScriptsContainer />
              </SessionUnauthorizedHandler>
            </OktaProvider>
          </InitialSessionLoaderProvider>
        </AppThemeProvider>
      </AttributionCaptureProvider>
    </TeamConfigProvider>
  );
};
